{
  "date": "{{day}} {{month}}, {{year}}",
  "header": "Félicitations, {{firstName}}! L'agent(e) est en train de traiter votre transaction.",
  "downPayment": {
    "last4": "<p>Votre plan de paiement est prêt. Aujourd'hui, nous allons débiter <strong><downPayment /></strong> sur votre carte se terminant par <strong>{{last4}}</strong>.</p>",
    "noLast4": "<p>Votre plan de paiement est prêt. Aujourd'hui, nous allons débiter <strong><downPayment /></strong> sur votre carte.</p>"
  },
  "noDownPayment": {
    "last4": "<p>À des fins d'authentification, il est possible qu'un montant de 0 $ soit inscrit sur votre compte dont le numéro se termine par <strong>{{last4}}</strong>.</p>",
    "noLast4": "<p>À des fins d'authentification, il est possible qu'un montant de 0 $ soit inscrit sur votre compte.</p>"
  },
  "uplift": {
    "payLink": "https://pay.uplift.com",
    "starting-next-month": "<p>Votre premier paiement mensuel de <strong><monthlyPayment /></strong> sera dû le <strong><dueDate /></strong>. Ne vous inquiétez pas, Uplift vous informera avant l'échéance de chaque paiement.</p>",
    "manage-loan": "<p>Vous pouvez toujours gérer votre prêt, consulter les paiements à venir ou nous poser des questions à <0>pay.uplift.com</0>. Il suffit de vous connecter en utilisant votre numéro de téléphone!</p>",
    "thank-you": "<p>Merci d’utiliser Uplift!</p>"
  },
  "flexpay": {
    "payLink": "https://upgrade.com/pay",
    "starting-next-month": "<p>Votre première mensualité de <monthlyPaymentAuto><monthlyPayment /></monthlyPaymentAuto> sera due le <firstPaymentDateAuto><dueDate /></firstPaymentDateAuto>. Ne vous inquiétez pas, Flex Pay vous informera avant chaque échéance.</p>",
    "manage-loan": "<p>Vous pouvez toujours gérer votre prêt, consulter les paiements à venir ou nous poser des questions sur <0>upgrade.com/pay</0>. Il vous suffit de vous connecter en utilisant votre numéro de téléphone!</p>",
    "thank-you": "<p>Merci d’utiliser Flex Pay!</p>"
  }
}
